/* eslint-disable camelcase */
import { createTheme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

// Extend palette property colors
declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    colors: {
      blue: string;
      green: string;
      teal: string;
      white: string;
      gray1: string;
      gray2: string;
      gray3: string;
      gray4: string;
      gray4_5: string;
      gray5: string;
      gray6: string;
      darkBlue: string;
      yellow: string;
      yellowLight: string;
      red: string;
      orange: string;
      greenDegrade: string;
      lightYellow: string;
      lightBlue: string;
      darkerBlue: string;
      leafletRoute: string;
    };
  }

  interface PaletteOptions {
    colors?: {
      blue: string;
      green: string;
      teal: string;
      white: string;
      gray1: string;
      gray2: string;
      gray3: string;
      gray4: string;
      gray4_5: string;
      gray5: string;
      gray6: string;
      darkBlue: string;
      yellow: string;
      yellowLight: string;
      red: string;
      orange: string;
      greenDegrade: string;
      lightYellow: string;
      lightBlue: string;
      darkerBlue: string;
      leafletRoute: string;
    };
  }
}

const theme = createTheme({
  spacing: (factor) => `${0.5 * factor}rem`.replaceAll('rem1', 'rem'),
  palette: {
    primary: {
      main: '#249eb2',
    },
    secondary: {
      main: grey[900],
    },
    colors: {
      blue: '#249EB2',
      green: '#5cc3b4',
      teal: '#2093a2',
      white: '#fff',
      gray1: '#333333',
      gray2: '#4F4F4F',
      gray3: '#828282',
      gray4: '#CFCFCF',
      gray4_5: '#B0B0B0',
      gray5: '#EFEFEF',
      gray6: '#F8F8F8',
      darkBlue: '#188189',
      yellow: '#EA9427',
      yellowLight: '#EEB759',
      red: '#C81616',
      orange: '#EE7459',
      greenDegrade: '#65C2AF',
      lightYellow: '#EEB759',
      lightBlue: '#5FC0C2',
      darkerBlue: '#145A60',
      leafletRoute: '#3388ff',
    },
  },
});

export default theme;
